import type { AnyAction } from 'redux';

import { ACTIONS as loginActions } from 'actions/login';
import { ACTIONS as logoutActions } from 'actions/logout';
import { setUser } from 'modules/sentry';
import { errors } from 'redux-rest-reducer';
import { setCustomUserAttributesWebengage } from 'utils/analytics';
import { getUserIdFromCookie, getStudentServiceIdFromCookie } from 'utils/auth';

const userId = getUserIdFromCookie() || undefined;
const studentServiceId = getStudentServiceIdFromCookie() || undefined;
const loggedIn = !!userId;

export type AuthState = {
  loggedIn: boolean;
  userId?: string;
  studentServiceId?: string;
};

export const initialState: AuthState = {
  loggedIn,
  userId,
  studentServiceId,
};

export default function defaultExport(
  state = initialState,
  { type, payload }: AnyAction,
): AuthState {
  if (type === loginActions.LOGIN_SUCCESS) {
    if (window.webengage) {
      window.webengage.user.login(payload.user_id);
      window.webengage.user.setAttribute('userId', payload.user_id);
    }

    setUser(payload.user_id);
    setCustomUserAttributesWebengage({ userId: payload.user_id });

    return {
      loggedIn: true,
      userId: payload.user_id,
      studentServiceId: payload.student_service_id,
    };
  }

  if (type === logoutActions.POST_SUCCESS || type === errors[401]) {
    setUser(null);

    if (window.webengage) {
      window.webengage.user.logout();
    }

    return {
      loggedIn: false,
      studentServiceId: undefined,
      userId: undefined,
    };
  }

  return state;
}
